module.exports = __webpack_public_path__ + "static/seo-ea180ec1f46479bfe2f4209d102f2cfa.jpg";